/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';

xplenty.directive('unionEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./union-editor.html'),

      replace: true,

      controller: [
        '$scope',
        '$timeout',
        '$translate',

        'ComponentEditorListeners',
        function ($scope, $timeout, $translate, ComponentEditorListeners) {
          const onSaveSuccessCallback = function () {
            $scope._default.setInputComponentsOrder($scope.components);
          };
          ComponentEditorListeners.onSaveSuccess(onSaveSuccessCallback);

          $scope.$on('$destroy', function () {
            ComponentEditorListeners.clearOnSaveSuccessCb(onSaveSuccessCallback);
          });

          $scope.onRecordsChange = (records) => {
            $scope.component.fields = records;
          };

          $scope.$on(EVENTS.COMPONENTS_ORDER_EDITOR_SWITCH, function () {
            // temporary inner records that are used within fields collection can be exposed if binding innerRecords to collection component
            _.each($scope._records, function (record) {
              const temp = record.right;
              record.right = record.left;
              record.left = temp;
            });
          });
        },
      ],
    };
  },
]);
